import React, { useState, useMemo } from "react";
import { } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  Card,
  Row,
  Col,
  Button
} from '@lockerpm/design';

import {
  EditOutlined
} from "@ant-design/icons";

import { gray } from '@ant-design/colors';

import FormData from "../FormData";
import itemsComponents from "../../../../../components/items";
import InstallationGuideModal from "../InstallationGuideModal";

import {
  timeFromNow,
} from '../../../../../utils/common';

import global from "../../../../../config/global";
import storeActions from "../../../../../store/actions";

const General = (props) => {
  const { TextCopy, ProgrammingLanguage } = itemsComponents;
  const { t } = useTranslation();
  const {
    className = '',
    project = {}
  } = props;

  const [formVisible, setFormVisible] = useState(false);
  const [installationVisible, setInstallationVisible] = useState(false);

  const dataFields = useMemo(() => {
    if (project) {
      return [
        {
          name: t('project_info.project_name'),
          lg: 8,
          value: <TextCopy
            value={project.name}
            color={gray[2]}
          />
        },
        {
          name: t('common.created_time'),
          lg: 8,
          value: <TextCopy
            value={timeFromNow(project.creation_date)}
            color={gray[2]}
          />
        },
        {
          name: t('common.updated_time'),
          lg: 8,
          value: <TextCopy
            value={timeFromNow(project.updated_date)}
            color={gray[2]}
          />
        },
        {
          name: t('common.description'),
          lg: 8,
          value: <TextCopy
            value={project.description}
          />
        },
        {
          name: t('project.programming_language'),
          lg: 16,
          value: <ProgrammingLanguage
            name={project?.programming_language}
          />
        },
      ]
    }
    return []
  }, [project])

  return (
    <div className={className}>
      <Card
        title={<div className="flex items-center justify-between">
          <p className="font-bold">{t('project_info.general_information')}</p>
          {
            <Button
              type="primary"
              icon={<EditOutlined />}
              onClick={() => setFormVisible(true)}
            >
              {t('button.edit')}
            </Button>
          }
        </div>}
      >
        <Row gutter={[12, 24]}>
          {
            dataFields.map((f, i) => <Col
              key={i}
              lg={f.lg}
              md={8}
              sm={8}
              xs={24}
            >
            <p className="font-bold text-l mb-1">
              {f.name}
            </p>
            {f.value}
          </Col>)
          }
        </Row>
      </Card>
      <FormData
        item={project}
        visible={formVisible}
        onClose={() => setFormVisible(false)}
        onReload={(values) => {
          global.store.dispatch(storeActions.updateIsFetchProjects(true));
          if (values?.programming_language !== project?.programming_language) {
            setTimeout(() => {
              setInstallationVisible(true)
            }, 1000);
          }
        }}
      />
      <InstallationGuideModal
        visible={installationVisible}
        onClose={() => setInstallationVisible(false)}
      />
    </div>
  );
}

export default General;
